import { render, staticRenderFns } from "./personCenterMenu.vue?vue&type=template&id=243043f4"
import script from "./personCenterMenu.vue?vue&type=script&lang=js"
export * from "./personCenterMenu.vue?vue&type=script&lang=js"
import style0 from "./personCenterMenu.vue?vue&type=style&index=0&id=243043f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports